import { render, staticRenderFns } from "./PurchaseInvoiceList.vue?vue&type=template&id=00ef8810&lang=pug&"
import script from "./PurchaseInvoiceList.vue?vue&type=script&lang=js&"
export * from "./PurchaseInvoiceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PurchaseInvoiceList.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileSubTitle } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
installComponents(component, {
  VList,
  VListTile,
  VListTileSubTitle,
  VListTileTitle,
  VSubheader,
})
